import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row,CardBody, CardHeader, Card, FormGroup, Label, Input, Button,
	/*InputGroup,
InputGroupAddon,
InputGroupText*/
 } from 'reactstrap';
import { find, toggleData,recoverPasword } from '../../store/actions/userActions';
import { findCompany } from '../../store/actions/companyActions';

class Password extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.props.find(this.props.match.params.id,this.props.match.params.token)
    }

    onChange = (target) => {
        let { name, value } = target,
            data = {
                'name': name,
                'data': value
            };
        this.props.toggleData(data);
    }

    render = () => {
        let accountType='falta tipo de usuario'
        if(this.props.account.client){
            accountType='client'
        }else if(this.props.account.provider){
            accountType='provider'
        }else if(this.props.account.admin){
            accountType='admin'
        }

        return <div className="app flex-row align-items-center custom_bg" >
			<Container>
				<Row className="justify-content-center">
					<Col xs="12" sm="12" md="5" lg="5">
                        <Card>
                            <CardHeader>
                                <h4 className="text-center mb-0">Bienvenido - Crea tu contraseña</h4>
                            </CardHeader>
                            {
                                this.props.account && this.props.account.company_id?
                                <CardBody>
									<FormGroup>
										<Label >Nombre</Label>
										<Input disabled type="name" name="name" value={this.props.account.name}/>
									</FormGroup>

									<FormGroup>
										<Label >Teléfono</Label>
										<Input disabled type="phone" name="phone" value={this.props.account.phone}/>
									</FormGroup>

									<FormGroup>
										<Label >Correo electrónico</Label>
										<Input disabled type="email" name="email" value={this.props.account.email}/>
									</FormGroup>

                                    <FormGroup>
                                        <Label htmlFor="password">{this.props.json_lang.confirmation.password}</Label>
                                        <Input type="password" name="password" placeholder={this.props.json_lang.confirmation.password} value={ this.props.account.password?this.props.account.password: '' } onChange={ (e) => this.onChange(e.target) }/>
                                    </FormGroup>

                                    <FormGroup>
                                        <Label htmlFor="password_confirmation">{this.props.json_lang.confirmation.confirm_password}</Label>
                                        <Input type="password" name="password_confirm" placeholder={this.props.json_lang.confirmation.confirm_password} value={ this.props.account.password_confirm?this.props.account.password_confirm:'' } onChange={ (e) => this.onChange(e.target) }/>
                                    </FormGroup>

                                    <Button color="primary btn-block" className="px-4" 
                                        disabled={
                                                this.props.account.company_id !== '' && 
                                                this.props.account.password !== '' && 
                                                this.props.account.password_confirm !== '' && 
                                                this.props.account.password === this.props.account.password_confirm ?
                                                false:true
                                        } 
                                        style={{height: '55px',fontWeight: 'bold'}} 
                                        onClick={()=>this.props.recoverPasword(accountType)}> {this.props.json_lang.common.save} 
                                    </Button>

                                </CardBody>
                                :
                                <CardBody>
                                </CardBody>
                            }
                        </Card>
					</Col>
				</Row>
			</Container>
		</div>
    }
}

const mapStateToProps = (state) => {
    return {
        errors: state.errors,
        account:state.account,
        json_lang: state.json_lang,
        company:state.company
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        find:(id,token) => dispatch(find(id,token)),
        toggleData: (data) => dispatch(toggleData(data)),
        recoverPasword: (type) => dispatch(recoverPasword(type)),
        findCompany: (id) => dispatch(findCompany(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Password);



// WEBPACK FOOTER //
// ./src/views/Password/Password.jsx